import { createAction } from "redux-actions";
import { GET_CODES_CORE, CREATE_CODES, CHANGE_CODES, CHANGE_STATE_USER, FIND_CODES_LOGIN_BY_USER } from "../constants";
//import {  serverUpdateCodes } from "./../services/codes";
import { feathersCreateData } from "./../services";
import { serverFindData } from "./../services/crud";



// export const getCodes = createAction(GET_CODES, (cedule) => serverGetCodes(urlCodes, cedule)())
// export const getCodes = createAction(GET_CODES, (cedule) => serverGetCodesFeathers(cedule)())
export const getCodes = createAction(GET_CODES_CORE, (startDate, endDate, SecuencialCuenta) => feathersCreateData('core-server', 
{
    service: 'ACCOUNT',
    func: 'RETURN MOVEMENTS ACCOUNTS BY NUMBER ACCOUNT',
    data: {
        SecuencialCuenta : SecuencialCuenta,
        FechaInicio: startDate,
        FechaFin: endDate,
    }
})())
//export const updateCodes = createAction(UPDATE_CODES, () => serverUpdateCodes()())
export const createCode = createAction(CREATE_CODES, (data) => feathersCreateData('codes-generate', data)())
export const changeCode = createAction(CHANGE_CODES, (data) => feathersCreateData('codes-generate', data)())

export const changeStatusUser = createAction(CHANGE_STATE_USER, (data) => feathersCreateData('codes-recovery', data)())
export const createCodeRecovery = createAction(CREATE_CODES, (data) => feathersCreateData('codes-recovery', data)())
export const changeCodeRecovery = createAction(CHANGE_CODES, (data) => feathersCreateData('codes-recovery', data)())
export const createCodeLogin = createAction(CREATE_CODES, (data) => feathersCreateData('codes-recovery', data)())
export const createCodeMeter = createAction(CREATE_CODES, (data) => feathersCreateData('codes-recovery', data)())
export const changeCodeLogin = createAction(CHANGE_CODES, (data) => feathersCreateData('codes-recovery', data)())
export const codeActivity = createAction(CHANGE_CODES, (data) => feathersCreateData('codes-recovery', data)())

export const findCodesLoginByUser = createAction(FIND_CODES_LOGIN_BY_USER, (query) => serverFindData("codes", query)())